export const translation = {
  // Navbar
  nav_spreadsheet: 'Spreadsheet',
  nav_categories: 'Kategorier',
  nav_guides: 'Guides',
  nav_shipping: 'Forsendelse',
  nav_qc: 'QC',
  nav_reviews: 'Anmeldelser',
  nav_language: 'Sprog',
  nav_cta: 'Besøg Hovedsiden',
  nav_home: 'Hjem',
  nav_shopping_guide: 'Indkøbsguide',

  // Hero
  hero_eyebrow: 'ALLCHINABUY SPREADSHEET RESSOURCECENTER',
  hero_title: 'AllChinaBuy Spreadsheet — Find Produkter, Sælgere og Købsguides',
  hero_desc: 'Leder du efter et AllChinaBuy spreadsheet? Udforsk kuraterede produktressourcer, sælgerinformation, QC-guides, forsendelsestips og praktiske købsguides — alt organiseret i ét brugervenligt ressourcecenter.',
  hero_cta_primary: 'Udforsk AllChinaBuy Spreadsheet',
  hero_cta_secondary: 'Gennemse Købsguides',
  hero_trust: 'Uafhængig ressource · Regelmæssigt opdateret · Flersproget',
  hero_search_placeholder: 'Søg efter AllChinaBuy spreadsheet, produkter, sælgere eller guides...',

  // Trust Bar
  trust_spreadsheet: 'Spreadsheet-Ressourcer',
  trust_spreadsheet_desc: 'Organiserede produkt- og sælgerinformationer.',
  trust_guides: 'Købsguides',
  trust_guides_desc: 'Praktiske guides for nye og erfarne brugere.',
  trust_qc: 'QC & Sikkerhed',
  trust_qc_desc: 'Forstå kvalitetskontroller og almindelige risici.',
  trust_shipping: 'Forsendelsesressourcer',
  trust_shipping_desc: 'Lær om forsendelsesmetoder, omkostninger og overvejelser.',

  // What Is Section
  what_is_title: 'Hvad er et AllChinaBuy Spreadsheet?',
  what_is_desc: 'Et AllChinaBuy spreadsheet er en praktisk måde at organisere produkt-, sælger- og indkøbsinformationer på ét sted. Vores ressourcecenter hjælper dig med at opdage nyttige ressourcer, forstå kategorier, sammenligne muligheder og lære købsprocessen.',
  what_is_cta: 'Udforsk Spreadsheet-Centeret →',

  // Categories Section
  categories_title: 'Gennemse Populære Kategorier',
  categories_cta: 'Udforsk Alle Kategorier →',

  // Popular Searches
  popular_title: 'Populære AllChinaBuy-Søgninger',
  popular_spreadsheet: 'AllChinaBuy Spreadsheet',
  popular_review: 'AllChinaBuy Anmeldelse',
  popular_shipping: 'AllChinaBuy Forsendelsesomkostninger',
  popular_coupon: 'AllChinaBuy Kupon',
  popular_discount: 'AllChinaBuy Rabatkode',
  popular_warehouse: 'AllChinaBuy Lager',
  popular_legit: 'AllChinaBuy Legitimt',
  popular_qc: 'AllChinaBuy QC',

  // Buying Guides
  guides_title: 'AllChinaBuy Købsguides',
  guides_desc: 'Lær at finde produkter, evaluere sælgere, forstå QC-information, estimere forsendelsesomkostninger og undgå almindelige fejl med praktiske AllChinaBuy-guides.',
  guides_cta: 'Se Alle Guides →',
  pillar_title: 'AllChinaBuy Kerneartikler',
  pillar_desc: 'Dybdegående originale guider om spreadsheets, anmeldelser, forsendelse, lager, QC, sælgere og sammenligninger.',
  guide_1_title: 'Komplet Spreadsheet-Guide',
  guide_1_desc: 'Mestre AllChinaBuy-spreadsheetet med vores omfattende guide.',
  guide_2_title: 'Forsendelsesomkostningsberegner',
  guide_2_desc: 'Estimer forsendelsesomkostninger før du køber med vores detaljerede opdeling.',
  guide_3_title: 'QC-Foto-Tjekliste',
  guide_3_desc: 'Lær hvad du skal se efter i kvalitetskontrolfotos hver gang.',
  guide_4_title: 'Sælger-Verifikationsguide',
  guide_4_desc: 'Hvordan man identificerer pålidelige sælgere og undgår almindelige svindel.',
  guide_5_title: 'Lagerproces Forklaret',
  guide_5_desc: 'Forstå hvordan AllChinaBuy-lageret håndterer dine varer.',
  guide_6_title: 'Begynder Købsstrategi',
  guide_6_desc: 'Vigtige tips for førstegangskøbere på AllChinaBuy.',

  // Comparison
  comparison_title: 'AllChinaBuy Sammenlignet med Andre Indkøbsplatforme',
  comparison_cta: 'Se Alle Sammenligninger →',
  vs_superbuy: 'AllChinaBuy vs Superbuy',
  vs_cssbuy: 'AllChinaBuy vs CSSBuy',
  vs_sugargoo: 'AllChinaBuy vs Sugargoo',
  vs_kakobuy: 'AllChinaBuy vs Kakobuy',

  // Safety Section
  safety_title: 'AllChinaBuy Sikkerhedscenter',
  safety_desc: 'Før du køber, lær at evaluere sælgere, beskytte din konto, genkende mistænkelige links, forstå betalingsrisici og træffe bedre informerede købsbeslutninger.',
  safety_cta: 'Besøg Sikkerhedscenteret →',

  // Review Section
  review_title: 'Er AllChinaBuy Legitimt?',
  review_desc: 'Undrer du dig over, om AllChinaBuy er legitimt, hvordan lageret fungerer, eller hvad du kan forvente af forsendelsen? Vores uafhængige guides forklarer de vigtigste overvejelser.',
  review_cta: 'Læs AllChinaBuy Anmeldelsen →',

  // FAQ
  faq_title: 'AllChinaBuy Spreadsheet FAQ',
  faq_q1: 'Hvad er et AllChinaBuy spreadsheet?',
  faq_a1: 'Et AllChinaBuy spreadsheet er en kurateret samling af produktlinks, sælgerinformationer og købsressourcer organiseret til nem reference.',
  faq_q2: 'Hvordan bruger jeg et AllChinaBuy spreadsheet?',
  faq_a2: 'Gennemse blot kategorierne, klik på produktlinks for at se detaljer, og følg købsguiderne for at fuldføre dit køb sikkert.',
  faq_q3: 'Er AllChinaBuy legitimt?',
  faq_a3: 'AllChinaBuy er en kendt indkøbsagentplatform. Som enhver onlinetjeneste er det vigtigt at forstå processen og følge sikkerhedsretningslinjer.',
  faq_q4: 'Er AllChinaBuy sikkert?',
  faq_a4: 'Sikkerhed afhænger af bedste praksis: verificer sælgere, brug QC-fotos, forstå forsendelsesomkostninger og læs vores sikkerhedsguides.',
  faq_q5: 'Hvad koster AllChinaBuy-forsendelse?',
  faq_a5: 'Forsendelsesomkostninger varierer efter destination, vægt og forsendelsesmetode. Brug vores guide til at estimere omkostninger før bestilling.',
  faq_q6: 'Har AllChinaBuy et lager?',
  faq_a6: 'Ja, AllChinaBuy driver lagre, hvor varer opbevares, inspiceres og konsolideres før international forsendelse.',
  faq_q7: 'Tilbyder AllChinaBuy kuponer eller rabatkoder?',
  faq_a7: 'Rabatkoder kan være tilgængelige periodisk. Tjek vores kuponguide for aktuelle tilbud.',
  faq_q8: 'Hvordan kontrollerer jeg produktkvalitet?',
  faq_a8: 'Anmod altid om QC-fotos (kvalitetskontrol) før forsendelse. Vores QC-guide forklarer præcis, hvad du skal se efter.',

  // Final CTA
  final_cta_title: 'Klar til at Udforske AllChinaBuy Spreadsheet?',
  final_cta_desc: 'Start med spreadsheet-hubben, udforsk populære produkter, sammenlign muligheder og lær købsprocessen med vores nyeste guides.',
  final_cta_primary: 'Udforsk AllChinaBuy Spreadsheet',
  final_cta_secondary: 'Besøg Hovedsiden',
  final_cta_buy_now: 'Køb Nu',

  // Footer
  footer_disclaimer: 'Denne hjemmeside er en uafhængig informationsressource. Det er ikke den officielle AllChinaBuy-hjemmeside, medmindre det udtrykkeligt er angivet. Informationer kan ændre sig, verificer venligst før køb.',
  footer_copyright: '© 2026 allchinabuyspread.cc — Alle rettigheder forbeholdt.',
  footer_links: 'Hurtige Links',
  footer_resources: 'Ressourcer',
  footer_legal: 'Juridisk',
  footer_privacy: 'Privatlivspolitik',
  footer_terms: 'Vilkår for Brug',
  footer_disclaimer_link: 'Ansvarsfraskrivelse',
  footer_contact: 'Kontakt',
  footer_about: 'Om Os',

  // Common
  allchinabuy_spreadsheet: 'AllChinaBuy Spreadsheet',
  read_more: 'Læs Mere',
  learn_more: 'Lær Mere',
  search: 'Søg',
  category: 'Kategori',
  product: 'Produkt',
  seller: 'Sælger',
  price: 'Pris',
  last_updated: 'Senest Opdateret',

  // Dropdown categories
  cat_shoes: 'Sko',
  cat_hoodies: 'Hoodies / Sweatre',
  cat_tshirts: 'T-Shirts',
  cat_jackets: 'Jakker',
  cat_pants: 'Bukser / Shorts',
  cat_headwear: 'Hovedbeklædning',
  cat_sets: 'Sæt',
  cat_underwear: 'Undertøj',
  cat_jersey: 'Trøjer',
  cat_accessories: 'Tilbehør',
  cat_bags: 'Tasker',
  cat_belts: 'Bælter',
  cat_perfumes: 'Parfumer',
  cat_other: 'Andre Ting',
};